<template>
  <el-dialog
    :visible.sync="visible"
    width="780px"
    :append-to-body="true"
  >
    <CalculateResultList v-if="visible" />
  </el-dialog>
</template>

<script>
import CalculateResultList from "./CalculateResultList.vue";

export default {
  name: "CalculateResultDialog",
  components: { CalculateResultList },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
  },
};
</script>
